export default {
  // 위험평가 항목 제안 결과
  getRiskSubtasks: state => state.riskSubtasks,

  // 재난 유형 정의 결과
  getRiskType: state => state.riskType,

  // 현재 안전보건조치 제안 결과
  getCurrentSafetyMeasures: state => state.currentSafetyMeasures,

  // 현재 위험도 점수 제안 결과
  getCurrentRiskPoint: state => state.currentRiskPoint,

  // 위험감소대책 제안 결과
  getRiskReductions: state => state.riskReductions,

  // 개선후 위험도 점수 제안 결과
  getAfterRiskPoint: state => state.afterRiskPoint,

  // 이미지 기반 위험성평가 분석 결과
  getImageRiskAnalysis: state => state.imageRiskAnalysis,

  // 이미지 분석 결과에서 유해위험요인 설명 목록만 반환
  getImageRiskFactors: state => {
    if (state.imageRiskAnalysis &&
        state.imageRiskAnalysis.success &&
        state.imageRiskAnalysis.data &&
        state.imageRiskAnalysis.data.유해위험요인_설명) {
      return state.imageRiskAnalysis.data.유해위험요인_설명
    }
    return []
  }
}
